import React from 'react';
import styles from '../program-sheet.module.scss';
import clsx from 'clsx';

type IconFC = React.FC<React.SVGProps<SVGSVGElement>> | React.FC;

interface Props {
  part1?: string;
  part2?: string;
  part3?: string;
  needSubscription?: boolean;
  IconComponent1?: IconFC;
  IconComponent2?: IconFC;
  isPlayerProductSheet?: boolean;
  className?: string;
}

const SheetStringIcons: React.FC<Props> = ({
  part1,
  part2,
  part3,
  IconComponent1,
  IconComponent2,
  isPlayerProductSheet = false,
  needSubscription = false,
  className
}) => {
  const labelClass = clsx(styles['sheet-string-icons__label'], {
    [styles['sheet-string-icons__label--player']]: isPlayerProductSheet
  });

  const rootClass = clsx(className, styles['sheet-string-icons'], {
    [styles['sheet-string-icons--player']]: isPlayerProductSheet
  });

  if (!part1 && !part2 && !part3 && !IconComponent1 && !IconComponent2 && !needSubscription) {
    return null;
  }

  const pairs: [string | undefined, IconFC | undefined][] = [
    [part1, IconComponent1],
    [part2, IconComponent2]
  ];

  return (
    <div className={rootClass}>
      {pairs.map(([label, Icon], i) => (
        <React.Fragment key={i}>
          {label && <span className={labelClass}>{label}</span>}
          {Icon && (
            <span className={styles['sheet-string-icons__icon']}>
              <Icon />
            </span>
          )}
        </React.Fragment>
      ))}
      {part3 && <span className={labelClass}>{part3}</span>}
      {needSubscription && (
        <span className={styles['sheet-string-icons__subscription-tag']}>Kræver abonnement</span>
      )}
    </div>
  );
};

export default SheetStringIcons;
